<template>
  <div id="app" v-if="!this.$route.path.match(/\/auth*/g)">
    <div id="wrapper">
      <sidebar/>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <navbar/>
          <div class="container-fluid ">
            <router-view/>
          </div>
        </div>
        <footer1/>
      </div>
    </div>
  </div>
  <div v-else>
    <router-view/>
  </div>
</template>

<script>
import Base from "@/utils/base";
import sidebar from './layout/sidebar'
import footer1 from './layout/footer'
import navbar from './layout/navbar'

export default {
  components: {
    sidebar, footer1, navbar,
  },
	data(){
		return {
			base: null,
		}
	},
  created(){
    if(sessionStorage.message != null){
      this.$toasted.show(sessionStorage.message)
      sessionStorage.removeItem('message')
    }

    // Notification.requestPermission( permission => {
    //   let notification = new Notification('New post alert!', {
    //     body: 'sagdjhsag', // content for the alert
    //   })

    //   notification.onclick = () => {
    //     alert('asdhjashjdhs')
    //   }
    // })
  },
  async mounted(){
		this.base = new Base()
		
		if(!this.$route.path.match(/\/auth*/g)){
			var token_expired = await window.localStorage.getItem('token_expired')
			if(token_expired != null)
				token_expired = moment(token_expired, 'YYYY-MM-DD HH:mm:ss')
			
			if(token_expired != null && token_expired.isBefore(moment())){
				this.base.show_error("Token Expired! Please login again")
				window.localStorage.removeItem('token')
				window.localStorage.removeItem('token_expired')
			
				window.location.href = "/auth/login"
				return
			}
		
		
    // if(!this.$route.path.match(/\/auth*/g))
    //   this.get_profile()
			
			const last_version = localStorage.getItem('version')
			if (last_version == null || (last_version != null && last_version !== this.base.app_version)) {
				localStorage.setItem('version', this.base.app_version)
				window.location.reload(true);
			}	
		}

    $('#userDropdown').dropdown()
  },
  methods:{
    async get_profile(){
      try{
        var response = await axios.get(base_url+'/auth/profile')

        var response_data = response.data
        if(response_data.status == "error"){
          location.href = "/auth/login"
          sessionStorage.message = response_data.message
          localStorage.removeItem('token')

        }
      } catch(e){
        this.$toasted.show(e.message)
      }
    },
  }
}
</script>
